import React from 'react'
import { Form, notification, Row, Col, Drawer } from 'antd'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { updateEnquiryStatusFxn } from '../../../unizHome/actions'
import { enquiryStatus } from '../../../components/_utils/utils'

const EnquiryStatusUpdateDrawer = (props) => {
  const dispatch = useDispatch()
  const {
    form: { getFieldDecorator, setFieldsValue, getFieldValue },
    onClose,
    refreshList,
    visible,
    enquiryId,
    selectedValue
  } = props


  let inputTypes = {
    fields: [
      {
        key: 'status',
        label: 'Select Status',
        placeholder: 'Select Status',
        required: true,
        showSearch: true,
        type: 'select',
        options: enquiryStatus,
        value: selectedValue,
        keyAccessor: (x) => `${x.value}`,
        valueAccessor: (x) => `${x.label}`,
        onChange: (value, option) => {
          setFieldsValue({
            status: value
          })
        }
      },
      {
        key: 'reason',
        label: 'Reason',
        type: 'text',
        hidden: getFieldValue('status') != 'drop',
        required: getFieldValue('status') == 'drop'
      }
    ]
  }


  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const handleSubmit = (e) => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.enquiryId = enquiryId
        let data = await dispatch(updateEnquiryStatusFxn(valData))
        if (data.success) {
          refreshList()
          onClose()

        }
      } else {
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }


  return (
    <React.Fragment>
      <Drawer visible={visible}
              title={`Update Status`}
              width={'50%'}
              closable={true}
              maskClosable={true}
              onClose={onClose}>
        <div className='card unizportal'>
          <div className='inner-form'>
            <Form onSubmit={handleSubmit} style={{ marginTop: 8, textAlign: 'left' }}>
              <Row gutter={24}>
                {inputTypes.fields.map((item, key) => {
                  return (
                    <Col span={item.span ? item.span : 24} md={item.span ? item.span : 24} sm={24} xs={24} key={key}>
                      <GetEachFormFields
                        item={item}
                        getFieldDecorator={getFieldDecorator}
                        formItemLayout={formItemLayout} />
                    </Col>
                  )
                })}
              </Row>

              <Form.Item>
                <button className='btn btn-default' type='submit'>Submit
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>

      </Drawer>
    </React.Fragment>
  )
}


export default Form.create()(EnquiryStatusUpdateDrawer)
